export const passwordRules = [
  {
    name: 'minLength',
    text: '12 characters minimum',
    valid: false,
  },
  {
    name: 'maxLength',
    text: '40 characters maximum',
    valid: false,
  },
  {
    name: 'specialCharacter',
    text: 'One special character',
    valid: false,
  },
  {
    name: 'lowerCaseCharacter',
    text: 'One lower-case character',
    valid: false,
  },
  {
    name: 'upperCaseCharacter',
    text: 'One upper-case character',
    valid: false,
  },
  {
    name: 'numberCharacter',
    text: 'One number',
    valid: false,
  },
  {
    name: 'repeatPassword',
    text: 'Repeat password',
    valid: false,
  },
];

export const supportURL = 'https://anthill.atlassian.net/servicedesk/customer/portal/8';
